import { Environment } from 'src/environments/environment';
import { Controller } from './interface/controller';
import { ControllerEndpoint } from './controller-endpoint';

export class ApiController implements Controller {
    constructor(
        public root: string,
        public endpoints: Map<string, ControllerEndpoint>,
        public baseUrl: string = Environment.ApiUrl
    ) { }
}
